import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { CNHealthProblem } from 'src/app/models/cnhealthproblem';
import { ProblemService, ProblemServiceFilter, ProblemServiceSubject } from 'src/app/services/problem.service';

@Component({
  selector: 'app-problem-list',
  templateUrl: './problem-list.component.html',
  styleUrls: ['./problem-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProblemListComponent implements OnInit {

  displayedColumns: string[] = ['problem'];
  private subject: ProblemServiceSubject;
  private myLocation = 'default';
  private myFilter = ProblemServiceFilter.active;
  public problems: CNHealthProblem[] = [];

  constructor(public problemservice: ProblemService, private changeDetection: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.problemservice.clear.subscribe(flag => {
      console.log('problems cleared');
    });
  }

  @Input() set location(theLocation: string) {
    this.myLocation = theLocation;
    this.subject = this.problemservice.getSubject(this.myLocation, this.myFilter, false);
    this.subject.problems.subscribe(data => {
      this.problems = data;
      this.changeDetection.markForCheck();
    });
  }
}
